import { Howl, Howler } from 'howler';

const createSoundFromSource = (relativePath, howlerOptions = {}) => {
  return new Howl({
    src: [window.PUBLIC_URL + relativePath],
    volume: 0.2,
    loop: false,
    ...howlerOptions,
  })
}

const master_track_fade_time = 3000 // in milliseconds
export const SOUND_MANAGER = {
  master_track_fade_time,
  setMasterVolume: (volume) => Howler.volume(volume),
  setVolume: (volume) => {
    Object.entries(SOUNDS).forEach(([key, sound]) => {
      sound.volume(volume)
    })
  },
  fadeInSound: (sound, level = null) => {
    sound.play()
    sound.fade(0, level || sound.volume(), master_track_fade_time) 
  },
  fadeOutSound: (sound) => {
    sound.fade(sound.volume(), 0, master_track_fade_time / 4)
    setTimeout(() => sound.stop(), master_track_fade_time / 4)
  },
  stopAll: () => {Howler.unload()}
}

export const SOUNDS = {
  // Telekinetic 
  level_lab: createSoundFromSource('/sounds/telekinetic/level_lab_1.mp3', {volume: .2, loop: true}),
  // Dark_Emptiness_015.wav by jalastram -- https://freesound.org/s/505697/ -- License: Attribution 4.0
  level_office: createSoundFromSource('/sounds/telekinetic/level_office.mp3', {loop: true}),
  // RoomTone EmptyMall indoors 02 160327_00.flac by klankbeeld -- https://freesound.org/s/455467/ -- License: Attribution 4.0
  level_construction: createSoundFromSource('/sounds/telekinetic/level_construction_2.mp3', {loop: true}),
  level_parking: createSoundFromSource('/sounds/telekinetic/level_parking.mp3', {loop: true}),
  // AMBUndr_underground parking gararge 1_TimKahn_MKH80208030st by tim.kahn -- https://freesound.org/s/789623/ -- License: Attribution 4.0
  level_boss: createSoundFromSource('/sounds/telekinetic/level_boss.mp3', {loop: false}),

  mind: createSoundFromSource('/sounds/telekinetic/mind.mp3'),
  // END Telekinetic 

  // UI
  menu_01: createSoundFromSource('/sounds/ui/menu-01.mp3', {rate: 2}),
  menu_02: createSoundFromSource('/sounds/ui/menu-02.mp3'),
  menu_03: createSoundFromSource('/sounds/ui/menu-03.mp3'),
  menu_04: createSoundFromSource('/sounds/ui/menu-04.mp3'),
  // UIGlitch_On Screen Glitch Patch x 6_EM by newlocknew -- https://freesound.org/s/791123/ -- License: Attribution NonCommercial 4.0
  // END UI

  pass_turn: createSoundFromSource('/sounds/hidden_leaf/pass_turn.mp3'),
  status_effect_applied: createSoundFromSource('/sounds/hidden_leaf/status_effect_applied.mp3'),
  not_allowed: createSoundFromSource('/sounds/hidden_leaf/not_allowed.mp3'),
  speed_up: createSoundFromSource('/sounds/hidden_leaf/speed_up.mp3'),

  hidden_gate_0: createSoundFromSource('/sounds/hidden_leaf/hidden_gate_0.wav'),
  hidden_gate_1: createSoundFromSource('/sounds/hidden_leaf/hidden_gate_1.wav'),

  summon_1: createSoundFromSource('/sounds/hidden_leaf/summon_1.wav'),
  summon_2: createSoundFromSource('/sounds/hidden_leaf/summon_2.wav'),
  summon_3: createSoundFromSource('/sounds/hidden_leaf/summon_2.wav', {rate: 0.6}),

  jutsu_strike: createSoundFromSource('/sounds/hidden_leaf/jutsu-strike.wav'),
  katon: createSoundFromSource('/sounds/hidden_leaf/katon.wav'),

  chakra_leech: createSoundFromSource('/sounds/hidden_leaf/chakra_leech.wav'),

  shadow_move: createSoundFromSource('/sounds/hidden_leaf/shadow-hold.wav'),

  sword_clang: createSoundFromSource('/sounds/hidden_leaf/sword_clang.wav'),

  beast_bomb: createSoundFromSource('/sounds/hidden_leaf/beast_bomb.mp3', {rate: 4, volume: .6}),
  
  bottle_open: createSoundFromSource('/sounds/hidden_leaf/bottle_open.mp3', {rate: 0.8, volume: .6}),

  wood_button: createSoundFromSource('/sounds/hidden_leaf/wood_block.mp3'),
  title_theme: createSoundFromSource('/sounds/telekinetic/title_theme.mp3', {loop: true}),
  character_select_theme: createSoundFromSource('/sounds/hidden_leaf/character_select_theme.mp3', {loop: true}),
  tournament_theme: createSoundFromSource('/sounds/hidden_leaf/tournament_theme.mp3', {loop: true}),
  battle_theme_0: createSoundFromSource('/sounds/hidden_leaf/battle_theme_0.mp3', {loop: true}),
  win_theme: createSoundFromSource('/sounds/telekinetic/win_theme.mp3'),
  lose_theme: createSoundFromSource('/sounds/telekinetic/lose_theme.mp3'),
  ambient_howling: createSoundFromSource('/sounds/tall_grass/ambient_loop_howls.mp3', {loop: true, rate: 0.75, volume: 0.1}),
  wind_loop: createSoundFromSource('/sounds/tall_grass/wind_loop.mp3', {loop: true, rate: 0.75, volume: 0.1}),
  wind_loop_2: createSoundFromSource('/sounds/hidden_leaf/Wind.wav', {loop: true}),
  taiko_drum_loop: createSoundFromSource('/sounds/hidden_leaf/taiko_drum_loop.mp3'),
  take_melee_hit: createSoundFromSource('/sounds/tall_grass/monster/sac_01.ogg'),
  sac_01: createSoundFromSource('/sounds/tall_grass/monster/sac_01.ogg'),
  sac_02: createSoundFromSource('/sounds/tall_grass/monster/sac_02.ogg'),
  sac_03: createSoundFromSource('/sounds/tall_grass/monster/sac_03.ogg'),
  screech_01: createSoundFromSource('/sounds/tall_grass/monster/screech_01.ogg'),
  screech_02: createSoundFromSource('/sounds/tall_grass/monster/screech_02.ogg'),
  screech_03: createSoundFromSource('/sounds/tall_grass/monster/screech_03.ogg'),
  // jutsus
  basic_jutsu_cast: createSoundFromSource('/sounds/hidden_leaf/hand_sign_activation.wav', {volume: 1}),
  sand_wall_01: createSoundFromSource('/sounds/hidden_leaf/sand_wall.wav', {volume: 0.6}),
  sand_clone_01: createSoundFromSource('/sounds/hidden_leaf/sand_clone.wav', {volume: 1}),
  swift_move: createSoundFromSource('/sounds/hidden_leaf/swift-move.wav', {volume: 1}),
  scratch_attack: createSoundFromSource('/sounds/hidden_leaf/scratch-attack.wav', {volume: 1}),
  wind_slice: createSoundFromSource('/sounds/hidden_leaf/wind_slice.wav', {volume: 0.6}),
  // kunai throw
  kunai_throw_01: createSoundFromSource('/sounds/hidden_leaf/kunai_throw.wav', {volume: 1.8}),
  kunai_throw_02: createSoundFromSource('/sounds/hidden_leaf/kunai_throw_2.wav', {volume: 1.8}),
  // melee hits
  punch_01: createSoundFromSource('/sounds/hidden_leaf/punch--01.mp3'),
  punch_02: createSoundFromSource('/sounds/hidden_leaf/punch--02.mp3'),
  punch_03: createSoundFromSource('/sounds/hidden_leaf/punch--03.mp3'),
  punch_04: createSoundFromSource('/sounds/hidden_leaf/punch--04.mp3'),
  punch_05: createSoundFromSource('/sounds/hidden_leaf/punch--05.mp3'),
  punch_06: createSoundFromSource('/sounds/hidden_leaf/punch--06.mp3'),
  punch_07: createSoundFromSource('/sounds/hidden_leaf/punch--07.mp3'),
  punch_08: createSoundFromSource('/sounds/hidden_leaf/punch--08.mp3'),

  sword_clang: createSoundFromSource('/sounds/hidden_leaf/sword_clang.wav'),

  glass_object_melee_01: createSoundFromSource('/sounds/melee/glass_object_melee-01.mp3'),
  glass_object_melee_02: createSoundFromSource('/sounds/melee/glass_object_melee-02.mp3'),
  glass_object_melee_03: createSoundFromSource('/sounds/melee/glass_object_melee-03.mp3'),
  glass_object_melee_04: createSoundFromSource('/sounds/melee/glass_object_melee-04.mp3'),
  glass_object_melee_05: createSoundFromSource('/sounds/melee/glass_object_melee-05.mp3'),
  glass_object_melee_06: createSoundFromSource('/sounds/melee/glass_object_melee-06.mp3'),
  
  small_object_melee_01: createSoundFromSource('/sounds/melee/small_object_melee-01.mp3'),
  small_object_melee_02: createSoundFromSource('/sounds/melee/small_object_melee-02.mp3'),
  small_object_melee_03: createSoundFromSource('/sounds/melee/small_object_melee-03.mp3'),
  small_object_melee_04: createSoundFromSource('/sounds/melee/small_object_melee-04.mp3'),
  small_object_melee_05: createSoundFromSource('/sounds/melee/small_object_melee-05.mp3'),
  small_object_melee_06: createSoundFromSource('/sounds/melee/small_object_melee-06.mp3'),

  wooden_object_melee_01: createSoundFromSource('/sounds/melee/wooden_object_melee-01.mp3'),
  wooden_object_melee_02: createSoundFromSource('/sounds/melee/wooden_object_melee-02.mp3'),
  wooden_object_melee_03: createSoundFromSource('/sounds/melee/wooden_object_melee-03.mp3'),
  wooden_object_melee_04: createSoundFromSource('/sounds/melee/wooden_object_melee-04.mp3'),
  wooden_object_melee_05: createSoundFromSource('/sounds/melee/wooden_object_melee-05.mp3'),

  heavy_object_melee_01: createSoundFromSource('/sounds/melee/heavy_object_melee-01.mp3'),
  heavy_object_melee_02: createSoundFromSource('/sounds/melee/heavy_object_melee-02.mp3'),
  heavy_object_melee_03: createSoundFromSource('/sounds/melee/heavy_object_melee-03.mp3'),
  
  object_slide_01: createSoundFromSource('/sounds/move/object_slide-01.mp3'),
  object_slide_02: createSoundFromSource('/sounds/move/object_slide-02.mp3'),
  object_slide_03: createSoundFromSource('/sounds/move/object_slide-03.mp3'),

  whoosh_01: createSoundFromSource('/sounds/move/whoosh-01.mp3'),
  whoosh_02: createSoundFromSource('/sounds/move/whoosh-02.mp3'),
  whoosh_03: createSoundFromSource('/sounds/move/whoosh-03.mp3'),

  // end
  // take damage
  take_damage_01: createSoundFromSource('/sounds/hidden_leaf/take-damage-01.mp3', {volume: 0.2}),
  take_damage_02: createSoundFromSource('/sounds/hidden_leaf/take-damage-02.mp3', {volume: 0.2}),
  take_damage_03: createSoundFromSource('/sounds/hidden_leaf/take-damage-03.mp3', {volume: 0.2}),
  take_damage_04: createSoundFromSource('/sounds/hidden_leaf/take-damage-04.mp3', {volume: 0.2}),
  take_damage_05: createSoundFromSource('/sounds/hidden_leaf/take-damage-05.mp3', {volume: 0.2}),
  take_damage_06: createSoundFromSource('/sounds/hidden_leaf/take-damage-06.mp3', {volume: 0.2}),
  take_damage_07: createSoundFromSource('/sounds/hidden_leaf/take-damage-07.mp3', {volume: 0.2}),
  take_damage_08: createSoundFromSource('/sounds/hidden_leaf/take-damage-08.mp3', {volume: 0.2}),
  take_damage_09: createSoundFromSource('/sounds/hidden_leaf/take-damage-09.mp3', {volume: 0.2}),
  take_damage_10: createSoundFromSource('/sounds/hidden_leaf/take-damage-10.mp3', {volume: 0.2}),
  take_damage_11: createSoundFromSource('/sounds/hidden_leaf/take-damage-11.mp3', {volume: 0.2}),
  // end
  // water
  water_01: createSoundFromSource('/sounds/hidden_leaf/water-01.mp3'),
  water_02: createSoundFromSource('/sounds/hidden_leaf/water-02.mp3'),
  water_03: createSoundFromSource('/sounds/hidden_leaf/water-03.mp3'),
  water_04: createSoundFromSource('/sounds/hidden_leaf/water-04.mp3'),
  water_05: createSoundFromSource('/sounds/hidden_leaf/water-05.mp3'),
  water_06: createSoundFromSource('/sounds/hidden_leaf/water-06.mp3'),
  // hard GROUND
  hard_ground_01: createSoundFromSource('/sounds/hidden_leaf/hard_ground-01.mp3'),
  hard_ground_02: createSoundFromSource('/sounds/hidden_leaf/hard_ground-02.mp3'),
  hard_ground_03: createSoundFromSource('/sounds/hidden_leaf/hard_ground-03.mp3'),
  hard_ground_04: createSoundFromSource('/sounds/hidden_leaf/hard_ground-04.mp3'),
  // grass GROUND
  grass_00: createSoundFromSource('/sounds/tall_grass/rustle/grass_00.mp3'),
  grass_01: createSoundFromSource('/sounds/tall_grass/rustle/grass_01.mp3'),
  grass_02: createSoundFromSource('/sounds/tall_grass/rustle/grass_02.mp3'),
  grass_03: createSoundFromSource('/sounds/tall_grass/rustle/grass_03.mp3'),
  grass_04: createSoundFromSource('/sounds/tall_grass/rustle/grass_04.mp3'),
  grass_05: createSoundFromSource('/sounds/tall_grass/rustle/grass_05.mp3'),
  grass_06: createSoundFromSource('/sounds/hidden_leaf/grass_06.mp3'),
  grass_07: createSoundFromSource('/sounds/hidden_leaf/grass_07.mp3'),
  // bug
  bug_step_01: createSoundFromSource('/sounds/hidden_leaf/bug_step1.wav'),
  bug_step_02: createSoundFromSource('/sounds/hidden_leaf/bug_step2.wav'),
  bug_step_03: createSoundFromSource('/sounds/hidden_leaf/bug_step3.wav'),
  bug_step_04: createSoundFromSource('/sounds/hidden_leaf/bug_step4.wav'),
  // end steps
  light_up: createSoundFromSource('/sounds/tall_grass/light_up.mp3'),
  light_drain: createSoundFromSource('/sounds/tall_grass/light_drain.mp3', {volume: 0.2}),
  emergence_01: createSoundFromSource('/sounds/jacinto/EarthDebrisSmallClose01.ogg'),
  emergence_02: createSoundFromSource('/sounds/jacinto/EarthDebrisSmallClose02.ogg'),
  cog_tags: createSoundFromSource('/sounds/jacinto/CogTags.ogg'),
  wretch_melee_01: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall01.ogg'),
  wretch_melee_02: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall03.ogg'),
  wretch_melee_03: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall04.ogg'),
  scion_melee_01: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall01.ogg', {rate: 0.5}),
  scion_melee_02: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall03.ogg', {rate: 0.5}),
  scion_melee_03: createSoundFromSource('/sounds/jacinto/actors/wretch/AAttackSmall04.ogg', {rate: 0.5}),
  locust_buff_01: createSoundFromSource('/sounds/jacinto/actors/drone/AChatterAttack01.ogg'),
  locust_buff_02: createSoundFromSource('/sounds/jacinto/actors/drone/AChatterAttack02.ogg'),
  locust_buff_03: createSoundFromSource('/sounds/jacinto/actors/drone/AChatterAttack03.ogg'),
  reload: createSoundFromSource('/sounds/jacinto/weapons/reloadassault02.ogg'),
  needs_reload: createSoundFromSource('/sounds/jacinto/NeedsReload01.ogg'),
  level_start: createSoundFromSource('/sounds/jacinto/ObjectiveAdd01.ogg'),
  level_end: createSoundFromSource('/sounds/jacinto/ObjectiveComplete01.ogg'),
  cog_rifle_fire_01: createSoundFromSource('/sounds/jacinto/weapons/Assault_Fire_02.ogg'),
  cog_rifle_fire_02: createSoundFromSource('/sounds/jacinto/weapons/Assault_Fire_07.ogg'),
  cog_rifle_fire_03: createSoundFromSource('/sounds/jacinto/weapons/CogARifleFire02.ogg'),
  cog_rifle_fire_04: createSoundFromSource('/sounds/jacinto/weapons/CogARifleFire04.ogg'),
  shot_missed_01: createSoundFromSource('/sounds/jacinto/weapons/BBulletImpact10.ogg'),
  shot_missed_02: createSoundFromSource('/sounds/jacinto/weapons/BBulletImpact1.ogg'),
  longshot_fire_01: createSoundFromSource('/sounds/jacinto/weapons/CogSniperFire01.ogg'),
  longshot_fire_02: createSoundFromSource('/sounds/jacinto/weapons/CogSniperFire02.ogg'),
  longshot_fire_03: createSoundFromSource('/sounds/jacinto/weapons/CogSniperFire03.ogg'),
  pistol_fire_01: createSoundFromSource('/sounds/jacinto/weapons/CogPistolFire01.ogg'),
  pistol_fire_02: createSoundFromSource('/sounds/jacinto/weapons/CogPistolFire02.ogg'),
  chainsaw_01: createSoundFromSource('/sounds/jacinto/weapons/ChainsawRevIdle01.ogg'),
  chainsaw_02: createSoundFromSource('/sounds/jacinto/weapons/ChainsawStart01.ogg'),
  grenade_ready: createSoundFromSource('/sounds/jacinto/weapons/GrenadeBeep02.ogg'),
  smoke_grenade_fire: createSoundFromSource('/sounds/jacinto/weapons/GrenadeSmokeSpew01.ogg'),
  boltok_fire_01: createSoundFromSource('/sounds/jacinto/weapons/LocustBoltok01.ogg'),
  boltok_fire_02: createSoundFromSource('/sounds/jacinto/weapons/LocustBoltok04.ogg'),
  hammerburst_fire_01: createSoundFromSource('/sounds/jacinto/weapons/LocustRifleFire01.ogg'),
  hammerburst_fire_02: createSoundFromSource('/sounds/jacinto/weapons/LocustRifleFire03.ogg'),
  bullet_hit_01: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactBodyFlesh01.ogg'),
  bullet_hit_02: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactBodyFlesh02.ogg'),
  bullet_hit_03: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactBodyFlesh03.ogg'),
  bullet_miss_01: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactDirt01.ogg'),
  bullet_miss_02: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactDirt02.ogg'),
  bullet_miss_03: createSoundFromSource('/sounds/jacinto/weapons/RifleAmmoImpactDirt03.ogg'),
  explosion_01: createSoundFromSource('/sounds/jacinto/weapons/BoomerExplosionA01.ogg'),
  explosion_02: createSoundFromSource('/sounds/jacinto/weapons/BoomerExplosionB01.ogg'),
}